module.exports = __webpack_public_path__ + "static/media/air-icon@3x.bbc51ad5.png";